import * as json from '../../../assets/supported-time-zones/supported-time-zones.json';

export const timezoneList: string[] = json['default'];
